import React from 'react';
import styled from 'styled-components';
import slugTransform from 'slug';

import Button from '../global/button';
import Top from '../top';
import mdToHtml from '../../util/mdToHtml';

const StyledContact = styled.div`
	text-align: center;
	h2 {
		margin-bottom: 3rem;
	}
	.flex {
		display: flex;
		padding: 0 4rem;
		justify-content: center;
		align-items: flex-start;
		flex-wrap: wrap;
		.location {
			width: calc(33.3% - 2rem);
			margin-right: 3rem;
			margin-bottom: 2rem;
			text-align: left;
			&:nth-child(3n) {
				margin-right: 0;
			}
			h3 {
				font-family: ${(p) => p.theme.fonts.heading};
				border-bottom: 1px solid ${(p) => p.theme.color.lightGrey};
				padding-bottom: 0.25rem;
			}
			.phone {
				color: ${(p) => p.theme.color.dark};
				margin: -0.5rem 0 0.5rem;
				display: block;
			}

			/* Woodbridge Location */
			&:last-child {
				text-align: center;
				h3 {
					color: ${(p) => p.theme.color.red};
					&::before {
						content: 'Head Office: ';
					}
				}
			}
		}
	}
	@media all and (max-width: 950px) {
		.flex .location {
			width: calc(50% - 1rem);
			margin-right: 0;
			&:nth-child(2n - 1) {
				margin-right: 2rem;
			}
			&:last-child {
				text-align: left;
			}
		}
	}
	@media all and (max-width: 768px) {
		.flex {
			padding: 0;
		}
	}
	@media all and (max-width: 550px) {
		text-align: left;
		padding: 0 2rem;
		.flex {
			.location {
				width: 100%;
				&:nth-child(2n - 1) {
					margin-right: 0;
				}
			}
		}
	}
`;

export default ({ copy, locations }) => {
	return (
		<StyledContact>
			<Top color="red">{copy.top}</Top>
			<h2>{copy.heading}</h2>
			<div className="flex">
				{locations.map((x, i) => (
					<div className="location" key={i}>
						<h3>{x.title}</h3>
						<div
							className="md-content"
							dangerouslySetInnerHTML={{
								__html: mdToHtml(x.contact.location),
							}}
						/>
						<a className="phone" href={x.contact.phone.raw}>
							{x.contact.phone.formatted}
						</a>
						<div
							className="md-content"
							dangerouslySetInnerHTML={{
								__html: mdToHtml(x.contact.hours),
							}}
						/>
						<Button
							className="link"
							type="link"
							size="small"
							to={`/${slugTransform(x.title, { lower: true })}/`}
							bg="blue"
						>
							VISIT LOCATION PAGE
						</Button>
					</div>
				))}
			</div>
		</StyledContact>
	);
};
